import { tv } from '~/utils/tv'

export const InputCounterControlVariants = tv({
  base: [
    `grid grid-cols-[auto_1fr_auto] place-content-center w-full gap-onepulse duration-100 ease-in overflow-hidden
    bg-[var(--color-forms-fill-default)]
    has-[:placeholder-shown]:bg-forms-fill
    has-[:placeholder-shown]:border-transparent
    has-[:placeholder-shown]:border-none
    has-[:focus-within]:has-[:placeholder-shown]:bg-forms-fill-focused
  `,
  ],
  variants: {
    size: {
      md: 'h-medium rounded-form px-threepulse',
      ml: 'h-mediumlarge rounded-form px-threepulse',
      lg: 'h-large rounded-form px-threepulse',
      xl: 'h-extralarge rounded-largecontainer px-threepulse',
    },
    readOnly: {
      true: `
      cursor-not-allowed
      has-[:placeholder-shown]:bg-forms-fill-readonly
      has-[:placeholder-shown]:ring-forms-border-readonly
      has-[:placeholder-shown]:ring-quarterpulse
      `,
    },
    disabled: {
      true: `
      cursor-not-allowed
      has-[:placeholder-shown]:bg-forms-fill-disabled
      has-[:placeholder-shown]:ring-forms-border-disabled
      has-[:placeholder-shown]:ring-quarterpulse
      `,
    },
    hasFilled: {
      true: '',
    },
    hasError: {
      true: `
      has-[:placeholder-shown]:ring-forms-border-error
      has-[:placeholder-shown]:ring-quarterpulse
      has-[:placeholder-shown]:hover:ring-halfpulse
      `,
    },
  },
  compoundVariants: [
    {
      hasError: false,
      hasFilled: true,
      readOnly: false,
      disabled: false,
      class: `
        [&:not(:focus-within)]:bg-forms-fill-filled
        [&:not(:focus-within)]:border-forms-border-filled
        [&:not(:focus-within)]:border-quarterpulse
        [&:not(:focus-within)]:hover:border-halfpulse
      `,
    },
    {
      hasError: false,
      readOnly: false,
      disabled: false,
      class: `
        has-[:focus-within]:ring-action-border-focused
        has-[:focus-within]:ring-halfpulse
        has-[:focus-within]:bg-forms-fill-focused
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:bg-forms-fill-hovered
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:border-forms-border-hovered

      `,
    },
    {
      hasError: true,
      hasFilled: true,
      readOnly: false,
      disabled: false,
      class: `
      has-[:not(:placeholder-shown)]:ring-forms-border-error
      has-[:not(:placeholder-shown)]:bg-forms-fill-error
      has-[:not(:placeholder-shown)]:ring-quarterpulse
      has-[:not(:placeholder-shown)]:hover:ring-halfpulse
      has-[:not(:placeholder-shown)]:border-none
      `,
    },
    {
      hasError: false,
      hasFilled: true,
      readOnly: false,
      disabled: true,
      class: `
      has-[:not(:placeholder-shown)]:ring-forms-border-disabled
      has-[:not(:placeholder-shown)]:bg-forms-fill-disabled
      has-[:not(:placeholder-shown)]:ring-quarterpulse
      has-[:not(:placeholder-shown)]:border-none
      `,
    },
    {
      hasError: false,
      hasFilled: true,
      readOnly: true,
      disabled: false,
      class: `
        has-[:not(:placeholder-shown)]:ring-forms-border-readonly
        has-[:not(:placeholder-shown)]:bg-forms-fill-readonly
        has-[:not(:placeholder-shown)]:ring-quarterpulse
        has-[:not(:placeholder-shown)]:border-none
      `,
    },
  ],
  defaultVariants: {
    size: 'md',
    isFocused: false,
    hasError: false,
    readOnly: false,
    disabled: false,
  },
})
